import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import StaggeredAnimation from '../../components/ui/staggered-animation';

const Code = () => {
  return (
    <div className="space-y-6">
      <StaggeredAnimation delay={100} animation="fadeUp">
        <div>
          <h1 className="text-3xl font-bold text-foreground">⚙️ Code</h1>
          <p className="text-muted-foreground">internal repos, boilerplates, starter kits</p>
        </div>
      </StaggeredAnimation>

      <StaggeredAnimation delay={200} animation="fadeUp">
        <Card>
          <CardHeader>
            <CardTitle>Code Dashboard</CardTitle>
            <CardDescription>internal repos, boilerplates, starter kits</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">Code content will be displayed here...</p>
          </CardContent>
        </Card>
      </StaggeredAnimation>
    </div>
  );
};

export default Code;